module.exports = __webpack_public_path__ + "4ed6789ef62dc607990263c697f1a1a8.png";